import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5ca149c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "box card"
}
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { key: 1 }

import { ref, onMounted } from 'vue'
import router from '@/router'
import DiplomaService from '@/services/DiplomaService'
import { useAuth } from '@/store/useAuth'


export default /*#__PURE__*/_defineComponent({
  __name: 'EvaluationList',
  props: ['content'],
  setup(__props) {

const store = useAuth()
const diplomaService = new DiplomaService()
const props = __props
const card = ref({
    id:0,
    name:'cargando...',
    description: 'cargando...',
    image_url: 'cargando...',
    number_of_questions: 0,
    questions_to_pass: 0,
    course_id: 0,
    max_tries: 0,
    created_at: 'cargando...',
    updated_at: 'cargando...'
})
const loading = ref(false)
const done = ref(false)

onMounted(async () => {
    loading.value = true
    card.value = props.content
    if(store.token) {
        const diplomas = await diplomaService.getAllDiplomasFromUser(store.token)
        diplomas.forEach(element => {
            if(element.course_id == card.value.course_id) {
                done.value = true
            }
        })
    }
    loading.value = false
})

const handleRoute = () => router.push({name: 'certification', params: {id: card.value.id }})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          name: "ri-loader-2-fill",
          animation: "spin",
          class: "icon"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass({animate:true, card:true, isDone:done.value})
      }, [
        _createElementVNode("div", _hoisted_2, [
          (!done.value)
            ? (_openBlock(), _createElementBlock("h4", {
                key: 0,
                class: "clickable",
                onClick: handleRoute
              }, _toDisplayString(props.content.name.substring(0,40)), 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_3, [
                _createTextVNode(_toDisplayString(props.content.name.substring(0,40)) + " ", 1),
                _createVNode(_component_v_icon, {
                  name: "bi-check-square-fill",
                  fill: "#fff"
                })
              ]))
        ])
      ], 2))
}
}

})